import type { ReactNode } from 'react'

export function HeaderAppWrap(props: {
  children: ReactNode
  className?: string
}) {
  return (
    <header className={'grid-in-header border-b-dotted-2 ' + props.className}>
      {props.children}
    </header>
  )
}
